import axios from 'axios';
import { Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeAllModals } from '../../actions/modalActions';
import { POST_TO_MAILCHIMP } from '../../constants/paths/api';
import SuccessOrFailure from '../successOrFailure';
import { newsletterFormInitialValues, newsletterSchema } from './newsletterForm.schema';
import * as StyledNewsletterForm from './newsletterForm.styles';
import NewsletterFormFields from './newsletterFormFields';

interface Props {
	termsLink?: string;
}

const NewsletterForm: FC<Props> = ({ termsLink }) => {
	const dispatch = useDispatch<any>();
	const { t } = useTranslation('generalForm');
	const [hasSubmitted, setHasSubmitted] = useState(false);
	const [error, setError] = useState(false);

	const onSubmit = values => {
		setHasSubmitted(true);
		setError(false);

		axios
			.post(`${POST_TO_MAILCHIMP}`, values)
			.then(response => {
				setHasSubmitted(true);
				setError(response.data.error);
				dispatch(closeAllModals());
			})
			.catch(() => {
				setHasSubmitted(true);
				setError(true);
			});
	};

	return (
		<StyledNewsletterForm.Wrapper>
			{!hasSubmitted && (
				<Formik
					initialValues={newsletterFormInitialValues}
					enableReinitialize
					validationSchema={newsletterSchema}
					onSubmit={onSubmit}>
					{({ handleSubmit, isSubmitting, values, setFieldTouched, setFieldValue }) => (
						<form onSubmit={handleSubmit}>
							<NewsletterFormFields
								termsLink={termsLink}
								isSubmitting={isSubmitting}
								values={values}
								setFieldTouched={setFieldTouched}
								setFieldValue={setFieldValue}
							/>
						</form>
					)}
				</Formik>
			)}
			<SuccessOrFailure
				hasSubmitted={hasSubmitted}
				success={!error}
				messageArray={[t('successMessagePostlist')]}
			/>
		</StyledNewsletterForm.Wrapper>
	);
};

export default NewsletterForm;
